/**
 * Helper module for matching conditions
 * @module
 */

var _ = require('optimizely-client-fn');

/**
 * Returns true if the value matches the  string
 * as defined by 'match' (ex: exists/exact/substring/regex)
 *
 * @param {string} value
 * @param {string} match
 * @param {null|string|number} visitorValue
 * @return {boolean}
 */
exports.hasMatch = function(value:string, match:string, visitorValue:null|string|number): boolean {
  var isUserValueDefined = !_.isUndefined(visitorValue) && visitorValue !== null;
  var isConditionValueDefined = !_.isUndefined(value) && value !== null;
  var matchType = match || (isConditionValueDefined ? 'exact' : 'exists');
  switch (matchType) {
    case 'exists':
      return isUserValueDefined;
    case 'exact':
      return isUserValueDefined && String(visitorValue) === value;
    case 'substring':
      return isUserValueDefined && String(visitorValue).indexOf(value) > -1;
    case 'regex':
      try {
        if (isConditionValueDefined && isUserValueDefined) {
          var regex = new RegExp(value);
          return regex.test(String(visitorValue));
        }
        return false;
      }
      catch (error) {} // eslint-disable-line
      return false;
    case 'range':
      // TODO(tyler): refactor?
      // range match type is currently used only by third-party dimensions
      var rangeValues = value.split(':');
      var fromValue = parseFloat(rangeValues[0]);
      var toValue = parseFloat(rangeValues[1]);
      var currentValue = parseFloat(visitorValue as string);

      return (currentValue >= fromValue && currentValue <= toValue);
    default:
      return false;
  }
};
